var _app_ = '/app/',
    _aimages_ = _static_ + 'app/layout/images/',
    noAvatar = _static_ + 'app/layout/images/no_avatar.png',
    defaultLogo = _static_ + 'app/layout/images/no-image.png',
    IE = 99,
    _default = 'dashboard',
    _current = 'dashboard',
    ActiveAutoComplete = 99,
    NumAutoComplete = -1,
    changingUser = false,
    lastEventTargetValue = 0;

/**
 * Time array
 */
var timeArray = ['00:00','00:15','00:30','00:45','01:00','01:15','01:30','01:45','02:00','02:15','02:30','02:45','03:00','03:15','03:30','03:45','04:00','04:15','04:30','04:45','05:00','05:15','05:30','05:45','06:00','06:15','06:30','06:45','07:00','07:15','07:30','07:45','08:00','08:15','08:30','08:45','09:00','09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:45','12:00','12:15','12:30','12:45','13:00','13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45','17:00','17:15','17:30','17:45','18:00','18:15','18:30','18:45','19:00','19:15','19:30','19:45','20:00','20:15','20:30','20:45','21:00','21:15','21:30','21:45','22:00','22:15','22:30','22:45','23:00','23:15','23:30','23:45','24:00'];
var timeMeridiumArray = ['12am', '12:15am', '12:30am', '12:45am', '1am', '1:15am', '1:30am', '1:45am', '2am', '2:15am', '2:30am', '2:45am', '3am', '3:15am', '3:30am', '3:45am', '4am', '4:15am', '4:30am', '4:45am', '5am', '5:15am', '5:30am', '5:45am', '6am', '6:15am', '6:30am', '6:45am', '7am', '7:15am', '7:30am', '7:45am', '8am', '8:15am', '8:30am', '8:45am', '9am', '9:15am', '9:30am', '9:45am', '10am', '10:15am', '10:30am', '10:45am', '11am', '11:15am', '11:30am', '11:45am', '12pm', '12:15pm', '12:30pm', '12:45pm', '1pm', '1:15pm', '1:30pm', '1:45pm', '2pm', '2:15pm', '2:30pm', '2:45pm', '3pm', '3:15pm', '3:30pm', '3:45pm', '4pm', '4:15pm', '4:30pm', '4:45pm', '5pm', '5:15pm', '5:30pm', '5:45pm', '6pm', '6:15pm', '6:30pm', '6:45pm', '7pm', '7:15pm', '7:30pm', '7:45pm', '8pm', '8:15pm', '8:30pm', '8:45pm', '9pm', '9:15pm', '9:30pm', '9:45pm', '10pm', '10:15pm', '10:30pm', '10:45pm', '11pm', '11:15pm', '11:30pm', '11:45pm', 'midnight'];

var INTEGRATION_VENDOR_ID_TCP = 10;

/**
 * Protect window.console method calls, e.g. console is not defined on IE
 * unless dev tools are open, and IE doesn't define console.debug
 *
 * Chrome 41.0.2272.118: debug,error,info,log,warn,dir,dirxml,table,trace,assert,count,markTimeline,profile,profileEnd,time,timeEnd,timeStamp,timeline,timelineEnd,group,groupCollapsed,groupEnd,clear
 * Firefox 37.0.1: log,info,warn,error,exception,debug,table,trace,dir,group,groupCollapsed,groupEnd,time,timeEnd,profile,profileEnd,assert,count
 * Internet Explorer 11: select,log,info,warn,error,debug,assert,time,timeEnd,timeStamp,group,groupCollapsed,groupEnd,trace,clear,dir,dirxml,count,countReset,cd
 * Safari 6.2.4: debug,error,log,info,warn,clear,dir,dirxml,table,trace,assert,count,profile,profileEnd,time,timeEnd,timeStamp,group,groupCollapsed,groupEnd
 * Opera 28.0.1750.48: debug,error,info,log,warn,dir,dirxml,table,trace,assert,count,markTimeline,profile,profileEnd,time,timeEnd,timeStamp,timeline,timelineEnd,group,groupCollapsed,groupEnd,clear
 */
(function () {
    // Union of Chrome, Firefox, IE, Opera, and Safari console methods
    var methods = ['assert', 'cd', 'clear', 'count', 'countReset',
            'debug', 'dir', 'dirxml', 'error', 'exception', 'group', 'groupCollapsed',
            'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd',
            'select', 'table', 'time', 'timeEnd', 'timeStamp', 'timeline',
            'timelineEnd', 'trace', 'warn'],
        length = methods.length,
        console = (window.console = window.console || {}),
        method,
        noop = function () {};

    while (length--) {
        method = methods[length];
        // define undefined methods as noops to prevent errors
        if (!console[method]) { console[method] = noop; }
    }
})();

(function (datepicker){
    $.fn.datepicker = function () {
        var args = arguments,
            defaults = $(this).data('datepickerOptions');

        if ('object' === typeof args[0] && 1 === args.length && defaults) {
            args[0] = $.extend({}, args[0], defaults);
        }

        return datepicker.apply(this, args);
    };
})($.fn.datepicker);

HTMLElement.prototype.getBoundingClientRect = (function () {
    var _getBoundingClientRect = HTMLElement.prototype.getBoundingClientRect;

    return function () {
        try {
            return _getBoundingClientRect.apply(this, arguments);
        } catch (e) {
            return {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            };
        }
    };
})();

/* ON BUG FUNCTION */
ERROR_THROWN = '';

window.onerror = function () {
    var argtype = typeof (arguments[0]);

    if ('object' === argtype) {

        ERROR_THROWN = arguments[0];

    } else if ('string' === argtype) {

        if (3 == arguments.length) {

            ERROR_THROWN.message = arguments[0];
            ERROR_THROWN.fileName = arguments[1];
            ERROR_THROWN.lineNumber = arguments[2];

        } else {

            ERROR_THROWN.message = arguments[0];

        }

    }

    ERROR_THROWN.userAgent = navigator.userAgent;

    return false;
};

function loadstaff(element) {
    var id = element.options[element.selectedIndex].value;

    if (id > 0) {
        $.get('/app/admin/access/load.php?id=' + DOMPurify.sanitize(id), function (data) {
            $('#listUsersFromStore').html(data);
        });
    }
}

function _status (NewStatus, Secs, afterPopUpFade) {
    if (!Secs) {
        Secs = 5;
    }
    NewStatus = NewStatus.indexOf('data-has-html-content') > -1 ? NewStatus : DOMPurify.sanitize(NewStatus);
    var el = document.getElementById('_status');

    $(el).html(NewStatus).fadeIn();

    if (el) {
        if (!el.hasAttribute('tabindex')){
            el.setAttribute('tabindex', '-1');
        }
        if (document.activeElement !== el) {
            _status.__prev = document.activeElement;
        }
        el.blur();
        setTimeout(function () {
            try {
                el.focus({ preventScroll: true });
            } catch (err) {
                el.focus();
            }
        }, 0);
    }
    clearStatus(Secs, afterPopUpFade);
}

function restoreStatusFocus () {
    var el = document.getElementById('_status'),
        p = _status.__prev;

    if (p && p.focus && el && document.activeElement === el) {
        try {
            p.focus({ preventScroll: true });
        } catch (err) {
            p.focus();
        }
    }
    _status.__prev = null;
}

/* Hide and show the Chloe chat. The Gainsight KC Bot is the other help surface and moves
   separately, see hideHelpChat() and showHelpChat() below. */
function hideChloeChat() {
    if ('undefined' !== typeof ChloeChat) {
        ChloeChat.hide();
    }
}

function showChloeChat() {
    if ('undefined' !== typeof ChloeChat) {
        ChloeChat.show();
    }
}

/* Both help surfaces at once, plus the user menu that reflects them. This is what the pages
   call: a floating widget that covers the publish button is a problem whichever one it is. */
function hideHelpChat() {
    updateChatMenuLinks(false);
    hideChloeChat();
    hideGainsightPxKcBot();
}

function showHelpChat() {
    updateChatMenuLinks(true);
    showChloeChat();
    showGainsightPxKcBot();
}

/* Swaps the "Show Help/Chat" and "Hide Help/Chat" items in the user menu. */
function updateChatMenuLinks(chatVisible) {
    var linkChatShow = document.getElementById('link-chloe-chat-show'),
        linkChatHide = document.getElementById('link-chloe-chat-hide');

    if (!linkChatShow || !linkChatHide) {
        return;
    }

    linkChatShow.style.display = chatVisible ? 'none' : 'inline';
    linkChatHide.style.display = chatVisible ? 'inline' : 'none';

    if ('undefined' !== typeof cal) {
        cal.helpchatVisible = chatVisible;
    }
}

function hideGainsightPxKcBot() {
    var gsPxKcBot = document.getElementById('apt-widget');

    if (gsPxKcBot) {
        gsPxKcBot.style.setProperty('pointer-events', 'none', 'important');
        gsPxKcBot.style.setProperty('opacity', '0', 'important');
    }
}

function showGainsightPxKcBot() {
    var gsPxKcBot = document.getElementById('apt-widget');

    if (gsPxKcBot) {
        gsPxKcBot.style.removeProperty('pointer-events');
        gsPxKcBot.style.removeProperty('opacity');
    }
}

function getTimelineForSegment() {
    if (cal.view === 'week') {
        return '1';
    }
    if (cal.view === 'twoweek') {
        return '2';
    }
    if (cal.view === 'month') {
        return '4';
    }
    return '0';
}

function isPaidAccount(){
    var checkCurrentDay = new moment(),
        paidUntilDate = new moment(business.paid_until_date);

    return paidUntilDate && paidUntilDate.isAfter(checkCurrentDay) && user.group_id <= '2';
}

function clearStatus (Secs, afterPopUpFade) {
    if (!Secs) {
        Secs = 5;
    }
    try {
        $(document).stopTime('hide');


        $(document).oneTime(Secs + 's', 'hide', function () {
            restoreStatusFocus();
            $('#_status').fadeOut();
            if (typeof afterPopUpFade === 'function'){ afterPopUpFade(); }
        });
    } catch (err) {
        restoreStatusFocus();
        $('#_status').fadeOut('slow');
    }
}

function CheckJSV (CurrentVersion) {
    if (CurrentVersion != _JSV_) {
        $('#_update').slideDown('slow');
    }
}

function HideLoginPrompt () {
    window.parent.$(document).oneTime('1000ms', 'DisplayHold', function () {
        window.parent.$('#darkBackgroundLayer').fadeOut('slow');
    });
    window.parent.$(document).oneTime('1000ms', 'DisplayHold', function () {
        window.parent.$('#hidiv').hide();
    });
}

function user_menu () {
    var umTO = '';

    clearTimeout(umTO);
    $('#userm').show();
    $('.j-arrowIconToAvatar').addClass('active');
    $('.j-arrowIconToAvatar').attr('aria-expanded', true);
    $('#userm a:first').focus();
}

function isValidPhone (phonenumber) {
    var goodChars = '+- 1234567890()';

    if ('' != phonenumber) {
        for (i = 0; i < phonenumber.length; i++) {
            var c = phonenumber.charAt(i);

            if (0 > goodChars.indexOf(c)) { return false; }
        }

        if (9 > phonenumber.length) {
            return false;
        }

        return true;
    }

    return false;
}

/*
 * S.T. 12.02.2012.
 * New implementation of the autologut feature
 * _autologouttime_ variable is set in main index.php file
 */

AUTOLOGOUT = {
    autologoutCookie: 'SPAUTOLOGOUT',
    logoutTimer: false,
    init: function () {
        // This needs to be checked first for the actions in other tabs
        this.autoLogout();

        if (0 !== _autologouttime_) {
            this.prolongAutologoutTimer();
        } else {
            AUTOLOGOUT.removeCookie();
        }

        $(function () {
            $(document).click(AUTOLOGOUT.prolongAutologoutTimer);
            $(document).keypress(AUTOLOGOUT.prolongAutologoutTimer);
        });
    },
    resetLogoutTimer: function () {
        var msLogoutTime = _autologouttime_ * 60000;

        clearTimeout(this.logoutTimer);
        this.logoutTimer = setTimeout(this.autoLogout, msLogoutTime);
    },
    prolongAutologoutTimer: function () {
        if (0 == _autologouttime_) {
            AUTOLOGOUT.removeCookie();
            return;
        }

        var msLogoutTime = _autologouttime_ * 60000;

        AUTOLOGOUT.removeCookie();

        StorageService.cookie.setCookie(
            AUTOLOGOUT.autologoutCookie,
            new Date().valueOf() + msLogoutTime,
            9999,
            true
        );

        clearTimeout(this.logoutTimer);
        this.logoutTimer = setTimeout(AUTOLOGOUT.autoLogout, msLogoutTime);
    },
    autoLogout: function () {
        var autoLogoutTime = StorageService.cookie.getCookie(AUTOLOGOUT.autologoutCookie);

        if ('undefined' == typeof (autoLogoutTime) || !autoLogoutTime || 'null' == autoLogoutTime || '' == autoLogoutTime) {
            return;
        }

        if (new Date().valueOf() < autoLogoutTime) {
            // case when user made some action in other tab/window and prolonged automatic logout
            AUTOLOGOUT.resetLogoutTimer();
        } else {
            // time expired and user is logged out
            AUTOLOGOUT.removeCookie();
            StorageService.localStorage.remove('locationData');
            window.location = _logout_;
        }
    },
    removeCookie: function () {
        StorageService.cookie.setCookie(AUTOLOGOUT.autologoutCookie, '', -1, true);
    }
};
AUTOLOGOUT.init();

function init ( ) {
    timeDisplay = document.createTextNode('');
    document.getElementById('clock').appendChild(timeDisplay);
}

function ajax (Url) {
    window.frames['hiframe'].location = Url;
}

function isValidEmail (str) {
    var re = /^(([^<>()[\]\\.,;:\s@\"']+(\.[^<>()[\]\\.,;:\s@\"']+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(str);
}

function isValidUsername (str) {
    return (2 < str.length) ? (!(/[^a-z0-9.]/.test(str))) : false;
}

/* WORK WITH URL HASH */
function IsNumeric (sText) {
    var ValidChars = '0123456789',
        IsNumber = true,
        Char;

    for (i = 0; i < sText.length && true == IsNumber; i++) {
        Char = sText.charAt(i);
        if (-1 == ValidChars.indexOf(Char)) {
            IsNumber = false;
        }
    }
    return IsNumber;
}

function validate_email (field) {
    var apos = field.indexOf('@');
    var dotpos = field.lastIndexOf('.');

    if (1 > apos || 2 > dotpos - apos) {
        return false;
    } else {
        return true;
    }
}

function isEmailSet (event, message) {
    $.iapi({
        module: 'staff.employee',
        method: 'GET',
        id: cal.user
    }, function (employee) {
        if (employee) {
            if (!isValidEmail(employee.email)){
                _status(message);
                event.preventDefault();
            }
        }
    },true , true);
}

/* add unique ids into array */
function mapUniqueIDs (array, itemsArray) {
    if (itemsArray) {
        for (var i = 0; i < itemsArray.length; i++) {
            if (-1 == $.inArray(itemsArray[i].id, array)) {
                array.push(itemsArray[i].id);
            }
        }
    }
}

function PosPop (NewWidth, NewHeight, TimeOut) {
    $('#hidiv').attr('className', 'ShiftPop');
    PopOpen = true;

    if ('number' == typeof (window.innerWidth)) {
        myWidth = window.innerWidth;
        myHeight = window.innerHeight;
    } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
        myWidth = document.documentElement.clientWidth;
        myHeight = document.documentElement.clientHeight;
    } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
        myWidth = document.body.clientWidth;
        myHeight = document.body.clientHeight;
    }

    var Top = ((myHeight / 2) - (NewHeight / 2));
    var Left = ((myWidth / 2) - (NewWidth / 2));

    if (300 < Top) {
        Top = 300;
    }

    if ('undefined' == typeof TimeOut) {
        if (50 > Top) {
            $('#hidiv').css({backgroundColor: '#ffffff', left: Left, top: '100px', width: NewWidth}).show();

        } else {
            $('#hidiv').css({backgroundColor: '#ffffff', left: Left, top: Top, width: NewWidth}).show();
        }
    } else {
        if (50 > Top) {
            $('#hidiv').animate({backgroundColor: '#ffffff', left: Left, top: '100px', width: NewWidth}, TimeOut);
        } else {
            $('#hidiv').animate({backgroundColor: '#ffffff', left: Left, top: Top, width: NewWidth}, TimeOut);
        }
    }
}

function EndShiftPop () {
    $('#hidiv').html(' ').hide();
}

function addslashes (str) {
    return str.replace('"', '\"');
}

function hide (Element) {
    document.getElementById(Element).style.display = 'none';
}

function show (Element) {
    document.getElementById(Element).style.display = 'block';
}

function setfocus (name) {
    document.getElementById(name).focus();
}

function ValidateUrl_App(Url) {
    var v = /^(https?|ftp):\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?::\d+)?(\/[^\s]*)?\/?$/,
        v_ip = /^(https?|ftp):\/\/((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?::\d+)?(\/[^\s]*)?\/?$/;

    return v.test(Url) || v_ip.test(Url);
}

function Validate_IP (ip) {
    if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ip)) {
        return (true);
    } else {
        return (false);
    }
}

function ChangeUsername () {
    var username = $('#NewUsername').val();

    if (3 > username.length) {
        alert(_s('Minimum 3 Chars Please'));
        return;
    }
    /* IS DUPLICATE USERNAME */
    $.post('/process/sales.php', {Action: 'UserNameCheck', username: username},
        function (data) {
            if ('ok' == data) {
                $.post('/process/sales.php', {Action: 'UserNameSave', username: username},
                    function (data) {
                        if ('bad' != data) {
                            $('#unameresults').html(_s('Username saved as:') + ' <b>' + data + '</b>');
                        } else {
                            $('#NewUsername').focus();
                            alert(_s('Username Already in Use.'));
                        }
                    }
                );
            } else if ('bad_username' == data) {
                $('#NewUsername').focus();
                alert(_s('Username is Not Formatted Correctly.'));
            } else {
                $('#NewUsername').focus();
                alert(_s('Username Already in Use'));
            }
        }
    );
}

/* V2 JAVASCRIPT */
function loading () {
    requestActiveStatus(true);

    $('#loading').show();
}

function loaded () {
    var _last = 'dashboard';

    requestActiveStatus(false);

    $('#loading').hide();

    if (_current!=_last && _current !== 'staff'){
        $('#_cd_' + _last + ' .right').html('');
    }
}

function AutoSwap (Focus) {
    if ($('#q').val() == _s('search here')) {
        $('#q').val('');
        if (Focus) {
            $('#q').focus();
        }
    }
}

function AutoCompleteFinish (blurit) {
    $('#q').removeClass('actq');
    $('.sresults').html('').hide();
    if (blurit) {
        $('#q').blur().val(_s('search here'));
    }
    $(document).off('click', AutoSwap);
    NumAutoComplete = 0;
    ActiveAutoComplete = 99;
}

function AutoCompleteDown () {
    if (-1 < NumAutoComplete) {
        if (99 == ActiveAutoComplete) {
            ActiveAutoComplete = 0;
        } else if (ActiveAutoComplete == NumAutoComplete) {
            ActiveAutoComplete = 0;
        } else {
            ActiveAutoComplete++;
        }
        AutoCompleteFocusItem();
    }
}

function AutoCompleteUp () {
    if (-1 < NumAutoComplete) {
        if (99 == ActiveAutoComplete) {
            ActiveAutoComplete = NumAutoComplete;
        } else if (0 == ActiveAutoComplete) {
            ActiveAutoComplete = NumAutoComplete;
        } else {
            ActiveAutoComplete--;
        }
        AutoCompleteFocusItem();
    }
}

function AutoCompleteFocusItem () {
    $('.itm').removeClass('itmact');
    $('#ac' + ActiveAutoComplete).addClass('itmact');
}

function AutoCompleteSelectItem () {
    if (-1 < ActiveAutoComplete && 99 > ActiveAutoComplete) {
        $('#ac' + ActiveAutoComplete).click();
    }
}

function AutoCompleteFill (data) {

    $('.sresults').html('').slideDown();
    NumAutoComplete = -1;
    ActiveAutoComplete = 99;

    /* DISPLAY DATE */
    $.each(data.date, function (i, item) {
        NumAutoComplete++;
        $('.sresults').append('<div class="itm" id="ac' + NumAutoComplete + '" onclick="scheduleRouter.loadSchedule(\'schedule\'); parsedate(\'' + item[1] + '\'); calendar({view: \'day\'}); AutoCompleteFinish(true);">' + item[1] + '</div>');
    });

    /* DISPLAY EMPLOYEES */
    $.each(data.employees, function (i, item) {
        NumAutoComplete++;
        $('.sresults').append('<div class="itm" id="ac' + NumAutoComplete + '" onclick="_switch(\'staff\', true); _sub(\'staff\', \'OverView\', \'id=' + item[0] + '\'); AutoCompleteFinish(true);"><img src="' + item[1] + '">' + item[2] + '</div>');
    });
    /* DISPLAY TRAININGS */
    if ('undefined' != typeof data.trainings) {
        $.each(data.trainings, function (i, item) {
            NumAutoComplete++;
            $('.sresults').append('<div class="itm" id="ac' + NumAutoComplete + '" onclick="_load(\'training\'); _sub(\'training\',\'overview\',\'module=' + item[0] + '\');AutoCompleteFinish(true);">' + item[1] + '</div>');
        });
    }
    /* DISPLAY SHIFTNOTES */
    $.each(data.shiftnotes, function (i, item) {
        NumAutoComplete++;
        $('.sresults').append('<div class="itm" id="ac' + NumAutoComplete + '" onclick="scheduleRouter.loadSchedule(\'schedule\');  parsedate(\'' + item[2] + '\'); calendar({mode: \'schedule\', schedule: \'' + item[1] + '\', view: \'day\', focus: \'visual\'}); AutoCompleteFinish(true);"><b>' + item[0] + '</b><br />' + item[3] + '</div>');
    });

    /* DISPLAY SCHEDULES */
    $.each(data.schedules, function (i, item) {
        NumAutoComplete++;
        $('.sresults').append('<div class="itm" id="ac' + NumAutoComplete + '" onclick="scheduleRouter.loadSchedule(\'schedule\'); calendar({mode: \'schedule\', schedule: \'' + item[0] + '\', focus: \'visual\'}); AutoCompleteFinish(true);"><img src="' + _aimages_ + 'blank.gif" style="background-color: #' + item[1] + ';">' + item[2] + '</div>');
    });

    /* DISPLAY HELP TOPICS */
    $.each(data.topics, function (i, item) {
        NumAutoComplete++;
        $('.sresults').append('<div class="itm" id="ac' + NumAutoComplete + '" onclick="_switch(\'support\'); SupportTopic(' + item[0] + '); AutoCompleteFinish(true);">' + item[1] + '</div>');
    });

    if (0 > NumAutoComplete) {
        $('.sresults').html('').slideUp();
    }

}

var waitForFinalEvent = (function () {
    var timer = false,
        event = null;

    return function (callback, ms) {
        if (timer) {
            clearTimeout(event);
        }
        timer = true;
        event = setTimeout(callback, ms);
    };
})();

$(window).on('resize', function (e) {
    var clientHeight = e.target.outerHeight;

    waitForFinalEvent(function (){
        resizeleft(null, clientHeight);
    }, 600);
});


function resizeleft (LeftName, eventTargetHeight) {
    var NHeight,
        LHeight,
        RHeight,
        documentHeight,
        pageContainer = document.getElementById('_cd_' + _current),
        leftContainer,
        windowInnerHeight;

    if (!pageContainer) {
        return false;
    }

    leftContainer = pageContainer.querySelector('.left');

    if (_current !== 'staff') {
        leftContainer.style.height = 0;
    }

    $('#setup_slide').height('');

    if (!LeftName) {
        LeftName = 'lheight';
    }

    documentHeight = document.body.offsetHeight;
    NHeight = $('#_topnav').height();
    LHeight = $('#_cd_' + _current + ' .' + LeftName).height() || 0;
    RHeight = $('#_body').height();
    windowInnerHeight = window.innerHeight;
    if ( _current === 'staff') {
        if (document.querySelector('.Tags') || document.querySelector('#BreakRulesWrapper')) {
            leftContainer.style.height = windowInnerHeight - NHeight - 30 + 'px';

            return false;
        }
        if (documentHeight > LHeight && documentHeight > RHeight) {
            if (eventTargetHeight && eventTargetHeight !== documentHeight &&
                ( lastEventTargetValue !== Math.floor(eventTargetHeight) && lastEventTargetValue !== 0 )) {
                leftContainer.style.height = windowInnerHeight - NHeight - 30 + 'px';
                lastEventTargetValue = Math.floor(eventTargetHeight);
            } else if (eventTargetHeight && eventTargetHeight !== documentHeight && lastEventTargetValue !== 0){
                leftContainer.style.height = windowInnerHeight - NHeight - 30 + 'px';
                lastEventTargetValue = Math.floor(eventTargetHeight);
            } else if (eventTargetHeight && eventTargetHeight !== documentHeight) {
                leftContainer.style.height = windowInnerHeight - NHeight - 30 + 'px';
                lastEventTargetValue = Math.floor(eventTargetHeight);
            } else {
                leftContainer.style.height = documentHeight - NHeight - 30 + 'px';
                lastEventTargetValue = 0;
            }
        } else if (RHeight > documentHeight) {
            leftContainer.style.height = RHeight - 15 + 'px';
        } else if (LHeight > documentHeight) {
            leftContainer.style.height = LHeight - 15 + 'px';
        }

        return false;
    }
    /* RESET TO BEST SIZE */
    if (documentHeight > LHeight && documentHeight > RHeight) {
        leftContainer.style.height = documentHeight - NHeight - 15 + 'px';
    } else if (RHeight > documentHeight) {
        leftContainer.style.height = RHeight - 15 + 'px';
    } else if (LHeight > documentHeight) {
        leftContainer.style.height = LHeight - 15 + 'px';
    }
}

function setLocationPositionsHeight(){
    var locationPositionsContainer =  document.getElementById('locations-positions-container'),
        NHeight = document.getElementById('_topnav').clientHeight,
        windowHeight = window.screen.availHeight,
        WinHeight = document.activeElement.clientHeight;

    if (locationPositionsContainer) {
        locationPositionsContainer.style.maxHeight =  windowHeight - NHeight - 320 + 'px';
    }
}

function preloading () {
    var myimages = new Array(),
        x;

    for (x = 0; x < preloading.arguments.length; x++) {
        myimages[x] = new Image();
        myimages[x].src = preloading.arguments[x];
    }
}

function ManSetLeft (Id) {
    $('#_cd_' + _current + ' .mi').removeClass('dent').addClass('mitem');
    $('#_cd_' + _current + ' .left .dentshadow').remove();
    $('#_cd_' + _current + ' .left #' + Id).addClass('dent').removeClass('mitem').after('<div class="dentshadow"></div>');
}

/* THIS WILL UPDATE THE ACTION PANEL ON A PAGE LOAD IF _UpdateActionList IS SET */
_UpdateActionList = false;
function updateActionsList () {

    if (false != _UpdateActionList) {

        _UpdateActionList = false;

        if ($('#dashActionLeft').is(':visible')) {

            $.get('/app/dashboard/widgets/actions.php', function (data) {

                $('#dashActionLeft').html(data);
                $('#dashActionLeft').find('div.dash_action_list').show();

            });
        }
    }

}

function isIE () {
    return (/msie/i.test(navigator.userAgent) && !/opera/i.test(navigator.userAgent)) || !!navigator.userAgent.match(/Trident\/7\./);
}

function isFireFox() {
    return /firefox/i.test(navigator.userAgent.toLocaleLowerCase());
}

function isMobileDevice() {
    var check = false;

    (function(a){ if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) { check = true; } })(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}

function qtipDelegation (qtipClass, qtipSelector) {

    $(document).on({
        mouseenter: function (event) {

            $(this).qtip({
                overwrite: false,
                position: {
                    at: 'top center',
                    my: 'bottom center',
                    adjust: {
                        x: 0,
                        y: -20
                    }
                },
                style: {
                    classes: qtipClass
                },
                show: {
                    event: event.type,
                    ready: true,
                    solo: true,
                    delay: 0
                },
                hide: {
                    event: 'mouseleave',
                    delay: 1
                }
            }, event);

        }

    }, qtipSelector);
}

var deep_value = function (obj, path){
    var i = 0,
        props = path.split('.'),
        pathLegth = props.length;

    for (i; i < pathLegth; i++){
        obj = obj[props[i]] ? obj[props[i]] : ' ';
    }

    return obj;
};

function conditionalSplitObj (obj, condition) {

    var temp={
        withConditionArray: [],
        noConditionArray: []
    };

    Object.keys(obj).forEach(function (key){

        if (obj[key][condition]) {
            temp.withConditionArray.push(obj[key]);
        } else {
            temp.noConditionArray.push(obj[key]);
        }
    });

    return temp;
}

function concatAndSortArrays (obj, prop1, prop2, prop3) {
    obj.withConditionArray = groupSortObjects(obj.withConditionArray, prop1, prop2, prop3);
    obj.noConditionArray = singleSortObjects(obj.noConditionArray, prop2);

    return obj.noConditionArray.concat(obj.withConditionArray);
}

function groupSortObjects (obj, prop1, prop2, prop3) {
    return Object.keys(obj).sort(function (a1, a2){
        var prop1SortItem1 = deep_value(obj[a1], prop1).toLowerCase().trim(),
            prop1SortItem2 = deep_value(obj[a2], prop1).toLowerCase().trim(),
            prop2SortItem1 = deep_value(obj[a1], prop2).toLowerCase().trim(),
            prop2SortItem2 = deep_value(obj[a2], prop2).toLowerCase().trim(),
            prop3SortItem1 = deep_value(obj[a1], prop3),
            prop3SortItem2 = deep_value(obj[a2], prop3);

        if (prop1SortItem1 === prop1SortItem2 || '' === prop1SortItem1 || '' === prop1SortItem2) {
            if (prop3SortItem1 === prop3SortItem2) {
                return (prop2SortItem1 < prop2SortItem2) ? -1 : (prop2SortItem1 > prop2SortItem2) ? 1 : 0;
            } else {
                return (prop3SortItem1 < prop3SortItem2) ? -1 : 1;
            }
        } else {
            return (prop1SortItem1 < prop1SortItem2) ? -1 : 1;
        }
    }).map(function (key){ return obj[key]; });
}

function singleSortObjects (obj, prop) {
    return Object.keys(obj).sort(function (a1, a2){
        var propSortItem1 = obj[a1][prop].toLowerCase(),
            propSortItem2 = obj[a2][prop].toLowerCase();

        return (propSortItem1 < propSortItem2) ? -1 : (propSortItem1 > propSortItem2) ? 1 : 0;
    }).map(function (key){ return obj[key]; });
}

function changeuser(element){
    var ID = element.options[element.selectedIndex].value;

    if (ID>0){
        changingUser = true;
        window.top.location.href = '/team/access/?remove=true&tid='+DOMPurify.sanitize(ID);
    }
}

$(function () {
    var accache = {},
        $toolTip = $('#q'),
        checkCurrentDay = new moment(),
        paidUntilDate = typeof business !== 'undefined' ? new moment(business.paid_until_date) : new moment();

    /* Wraping bottom nav links in sidebar */
    $('._navBottomtwo')
        .wrapAll('<ul class="bottom_nav"></ul>')
        .parent()
        .prependTo('.j-navBottom__userWrap');

    /* IS INTERNET EXPLORER */
    if (isIE()) {
        IE = 1;
    }

    //toggle on/off access nav bar for group accounts
    $('#accessNav [data-toggle=\'toggleAccessNavHide\']').on('click', function () {
        $('#accessNav').removeClass('openAccessNav').toggleClass('closeAccessNav');
        $('#accessNavButton').removeClass('closeAccessNav').toggleClass('openAccessNav');
    });
    $('#accessNavButton[data-toggle=\'toggleAccessNavShow\']').on('click', function () {
        $('#accessNav').removeClass('closeAccessNav').toggleClass('openAccessNav');
        $('#accessNavButton').removeClass('openAccessNav').toggleClass('closeAccessNav');
    });

    /* HOTKEYS */
    $(document).on('keydown', null, 'f1', function (evt) {
        window.open('https://helpdesk.humanity.com/','target=_blank');
        evt.stopPropagation( );
        evt.preventDefault( );
        return false;
    });

    /* MAIN NAV SHOW/HIDE */
    $('#_nav').mousemove(function (evt) {
        if (300 > $(document).width() - evt.pageX) {
            $('#_nav .rgt').show();
        } else {
            $('#mm_support').hide();
        }
    });

    CancelAutoComplete = 99;

    /* AUTO COMPLETE */
    $toolTip.on('keydown', null, 'Down', function (evt) {
        AutoCompleteDown();
        CancelAutoComplete = 1;
        evt.stopPropagation( );
        evt.preventDefault( );
        return false;
    });
    $toolTip.on('keydown', null, 'Up', function (evt) {
        AutoCompleteUp();
        CancelAutoComplete = 1;
        evt.stopPropagation( );
        evt.preventDefault( );
        return false;
    });
    $toolTip.on('keydown', null, 'Esc', function (evt) {
        AutoCompleteFinish(true);
        loaded();
        CancelAutoComplete = 1;
        evt.stopPropagation( );
        evt.preventDefault( );
        return false;
    });
    $toolTip.on('keydown', 'return', AutoCompleteSelectItem);

    var toggleTooltip = function toggleTooltipFunc () {
        if ($('#_nav').hasClass('nav--compact') || window.matchMedia('(max-width: 1024px)').matches) {
            $('.j-primary-navigation-qtip').qtip({
                overwrite: false,
                position: {
                    my: 'top center',
                    at: 'bottom center'
                },
                style: {
                    classes: 'qtip-pnav'
                },
                show: {
                    delay: 0,
                    event: 'mouseenter focusin'
                },
                hide: {
                    delay: 0,
                    event: 'mouseleave focusout'
                }
            });
        } else {
            $('.j-primary-navigation-qtip').qtip('destroy', true);
        }
    };

    toggleTooltip();

    NavCompact.init(toggleTooltip);

    $(window).resize(function () {
        toggleTooltip();
    });

    /* Main Nav Qtip */

    qtipDelegation('qtip-map','.tti-map');
    qtipDelegation('qtip-dark','.tti,#scheduler div.conflict');

    /* DRAGGABLE POPUPS */

    /* ACTIVATE LEFT MENU FUNCTION */
    $('.mi').on('click', function () {
        $('#_cd_' + _current + ' .mi').removeClass('dent').addClass('mitem');
        $('#_cd_' + _current + ' .left .dentshadow').remove();
        $(this).addClass('dent').removeClass('mitem').after('<div class="dentshadow"></div>');
        localStorage.setItem('isEnhancedUpdate', 'Enhanced Reporting' === $(this).text());
    });

    $('.mis').on('click', function () {
        $('#_cd_' + _current + ' .mis').removeClass('b');
        $(this).addClass('b');
    });

    /* MENU right corner */

    $(document)
        .on('click', function (e) {
            if ($(e.target).closest('#tr_avatar, .j-arrowIconToAvatar').length) { return; }

            $('#userm').fadeOut('slow');
            $('.j-arrowIconToAvatar').removeClass('active');
            $('.j-arrowIconToAvatar').attr('aria-expanded', false);
            AutoCompleteFinish(true);

        })
        .on('click', '.j-mainLogo', function () {
            var groupId = cal.employees[cal.user].group;

            if (groupId === '6') {
                _load('reports', true);
            } else if (groupId === '7') {
                _sub('fe', true);
            } else {
                _load('dashboard', true);
            }
            return false;
        })
        .on('click', '.j-show-new-shift-creation', function () {
            var $newCreationButton = $('.j-present-new-creation');

            if ($newCreationButton.length > 0) {
                $newCreationButton.remove();
            }

            if (!cal.new_shift_creation) {
                $('#scheduler').find('td.inlineactive').removeClass('inlineactive');
                $('.temps_list').remove();
            }

            cal.new_shift_creation = !cal.new_shift_creation;

            set_user_setting(JSON.stringify({'is_new_shift_creation_enabled': cal.new_shift_creation ? 1 : 0}));
        })
        .on('click', '.j-import-forecast', function () {
            forecast.import();
        });

    /* SEARCH */
    $toolTip.on('keyup', function () {

        delay(function () {

            if ('undefined' != typeof _lockdown_) {
                _status(_s('Please Complete Setup First'));
                return false;
            }

            if (1 == CancelAutoComplete) {
                CancelAutoComplete = 99;
                return;
            }

            var searchfor = $('#q').val();

            if (0 < searchfor.length) {

                $(document).on('click', AutoSwap);

                $('#q').removeClass('actq').addClass('actq');

                $('.sresults').html('').show();
                var cacheHandle = searchfor.toLowerCase();

                if (accache[cacheHandle]) {
                    AutoCompleteFill(accache[cacheHandle]);
                } else {
                    loading();
                    $.getJSON(_base_ + '/app/includes/results.php?q=' + searchfor, function (data) {
                        accache[cacheHandle] = data;
                        AutoCompleteFill(data);
                    });
                }

            } else {
                AutoCompleteFinish();
            }

        }, 20);

    });

    /* HANDLE AJAX ERROR CALLBACK */
    $.ajaxSetup({
        error: function (x, e) {
            if (404 == x.status) {
                _status(_s('Requested URL not found. Please Contact info@humanity.com if this persists.'), 5);
            } else if (500 == x.status) {
                _status(_s('Internal Server Error. Please Contact info@humanity.com if this persists.'), 5);
            } else if ('parsererror' == e) {

                /* _status('Error - Parsing JSON Request failed. Please Contact info@humanity.com if this persists.', 5);
                 * ASSUME USER IS LOGGED OUT
                 * */
                _status(i18n.format(_s('Your session has expired. Please <a href="{app}">Login</a> to continue.'), {'app': _app_ + '?logout=1'}), 30);

            } else if ('timeout' == e) {
                _status(_s('Request Time out. Please Try Again'), 5);
            }
        },
        beforeSend: function () {
            loading();
        },
        success: function () {
            loaded();
        },
        complete: function () {
            loaded();
            resizeleft();
        }
    });

    $('#tr_avatar, .j-arrowIconToAvatar').on('click', user_menu);
    $('#tr_avatar, .j-arrowIconToAvatar').on('keypress', function(event) {
        if (event.which === 13) {
            if ($('.j-arrowIconToAvatar').hasClass('active')) {
                $('#userm').fadeOut('slow');
                $('.j-arrowIconToAvatar').removeClass('active');
                $('.j-arrowIconToAvatar').attr('aria-expanded', false);
                AutoCompleteFinish(true);
            } else {
                user_menu();
            }

        }
    });
    $('#userm a:last').on('keydown', function (e) {
        if (!e.shiftKey && e.keyCode === 9) {
            e.preventDefault();
            $('.j-arrowIconToAvatar').focus();
        }
    });
    $('#userm a:first').on('keydown', function (e) {
        if (e.shiftKey && e.keyCode === 9) {
            e.preventDefault();
            $('.j-arrowIconToAvatar').focus();
        }
    });
});

Date.prototype.getMonthName = function () {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return months[this.getMonth()];
};

Date.prototype.getDayName = function () {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    return days[this.getDay()];
};

// IMAGE UPLOADER
$.fn.imageUploader = function (avatar, getId, url, formData, uplBtnId, dropZone, $parent) {
    if (!($parent instanceof jQuery)) {
        $parent = $($parent);
    }

    $(this).fileupload({
        url: url,
        formData: formData,
        dataType: 'json',
        // The regular expression for allowed file types, matches
        // against either file type or file name:
        acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
        // The maximum allowed file size in bytes:
        maxFileSize: 4000000, // 4MB
        autoUpload: true,
        dropZone: $('#' + dropZone + getId),
        //Remove this after jquery update
        drop: function (e, data) {
            if (!(data.files instanceof Array)){
                data.files = [data.files];
            }
        }

    }).on('fileuploadprocessalways', function (e, data) {
        var currentFile = data.files[data.index];

        if (data.files.error && currentFile.error) {
            // there was an error, do something about it
            window.alert(currentFile.error);
        } else {
            data.submit();
        }
    });

    $(this)
        .on('fileuploadsubmit', function () {
            var id = $(this).attr('id'),
                $container = $('<span class=\'asyncUploader\'/>');

            $('#' + uplBtnId).hide();

            if (!$('#' + id + '_completedMessage').length) {
                var contentHtml = '<div class=\'ProgressBar edit-employee__progress\'> <div class="edit-employee__progress-bar">&nbsp;</div> </div>' +
                    '<span id=\'' + id + '_completedMessage\'/>' +
                    '<span id=\'' + id + '_uploading\' class="edit-employee__uploading">Uploading...</span>' +
                    '<span id=\'' + id + '_swf\'/>' +
                    '<input type=\'hidden\' name=\'' + id + '_filename\' id=\'' + id + '_filename\'/>' +
                    '<input type=\'hidden\' name=\'' + id + '_guid\' id=\'' + id + '_guid\'/>';

                $('#' + uplBtnId).after($container);

                $container.append($(contentHtml));
            }

            $('#' + id + '_completedMessage').toggleClass('edit-employee__upload-success', Boolean($(this).data('is-profile-picture'))).hide();
            $('.ProgressBar').find('div').css('width', 0 + '%');
            $parent.find('.ProgressBar').show();
            $('#' + id + '_swf').hide();
            $('#' + id + '_uploading').show();
        })
        .on('fileuploaddone', function (e, data) {
            var id = $(this).attr('id'),
                resultToString = JSON.stringify(data.result);

            $('#' + id + '_filename').val(data.files[0].name);
            $('#' + id + '_guid').val(resultToString);

            var _guid = $('#' + id + '_guid').val(),
                urlsSourse = JSON.parse(_guid);

            $.each(data.files, function (index, file) {
                var fileSizeKb = Math.round(file.size / 1024);

                $('#' + id + '_completedMessage')
                    .show()
                    .html('<i class="icon icon-okCircle edit-employee__status-icon"></i>Uploaded {0} ({1} KB) &nbsp'
                        .replace('{0}', DOMPurify.sanitize(file.name))
                        .replace('{1}', fileSizeKb)
                    );
            });

            $('.ProgressBar').hide();
            $('#' + id + 'Wrapper').show();
            $('#' + id + 'Delete').removeClass('hide');
            $('#' + id + '_completedMessage').after($('#' + uplBtnId).show());
            $('#' + id + '_swf').show();
            $('#' + id + '_uploading').hide();
            $('#' + avatar).removeClass('is-hidden');

            $parent.find('.j-text-hint').show();
            $parent.find('#companyLogoDelete').removeClass('hide');

            uploadCompleted(avatar, _guid, getId);
            avatarExists(avatar, getId);
            setNewLogo(avatar, urlsSourse.small_url);
        })
        .on('fileuploadprogress', function (e, data) {
            var id = $(this).attr('id');

            $('#' + avatar).addClass('is-hidden');

            $(this)
                .closest('.j-branding-uploader')
                .find('.ProgressBar')
                .show()
                .find('div')
                .addClass('in-progress');

            $parent.find('.j-text-hint').hide();
        })
        .on('fileuploadfail', function (e, data) {
            var id = $(this).attr('id');

            _status(data.jqXHR.responseText);
            $('.ProgressBar').hide();
            $('#' + id + '_swf').show().html($('#' + uplBtnId).show());
            $('#' + id + '_uploading').hide();
            $('#' + id + 'Wrapper').show();

            $parent.find('.j-text-hint').show();
        });
};

$(document).on('drop dragover', function (e) {
    e.preventDefault();
});

function setNewLogo (avatarName, url) {

    if (avatarName !== 'companyLogo') {
        return false;
    }

    var $mainLogo = $('.j-main-logo-img');

    return $mainLogo.attr('src', url);
}

function uploadCompleted (avatar, _guid, getId) {
    _guid = JSON.parse(_guid);
    var tmpDate = new Date();

    ImageSuccess(avatar, _guid.small_url + '?' + tmpDate.getTime(), getId);

    if (user.id == getId) {
        $('#tr_avatar').attr('src', _guid.small_url + '?' + tmpDate.getTime());
        $('#userm img').attr('src', _guid.large_url + '?' + tmpDate.getTime());
    }
}

function ImageSuccess (avatar, Timestamp, UserId) {
    var newUserId = UserId ? UserId : '';

    _status(_s('Image Uploaded Successfully!'));

    $('#' + avatar + newUserId).show();
    $('#' + avatar + newUserId).attr('src', Timestamp);
    if (newUserId == _U_) {
        $('#DashBoardAvatar').attr('src', Timestamp);
    }
}

function avatarExists (avatar, getId){
    var newGetId = getId ? getId : '',
        avatarSrc = $('#' + avatar + newGetId).attr('src'),
        checkLogoSrc = avatarSrc ? avatarSrc.indexOf(defaultLogo) : -1;

    if (-1 === checkLogoSrc) {
        $('#logoText').hide();
    }

    $('#' + avatar + 'Delete')[defaultLogo.indexOf(avatarSrc) !== -1 ? 'addClass' : 'removeClass']('hide');

    $('#' + avatar + 'Delete span').off('click').on('click', function (){
        var confirmRemove = confirm('Your image will be removed?');

        if (confirmRemove) {
            $('#' + avatar + 'Delete').addClass('hide');
            deleteAvatar(avatar, newGetId);
            $('#' + avatar + 'Wrapper').off();
            $('#' + avatar).attr('src', defaultLogo);
        }
    });

    if ($('#' + avatar + 'Delete').closest('#branding-option').length === 0
        && '//:0' !== avatarSrc) {
        $('#' + avatar + 'Wrapper').on({
            mouseenter: function (){
                $('#' + avatar + 'Delete')[
                    noAvatar.indexOf($('.j-user-avatar-settings').attr('src')) === -1 ? 'show' : 'hide'
                ]();
            },
            mouseleave: function (){
                $('#' + avatar + 'Delete').hide();
            }
        });
    } else {
        $('#' + avatar + 'Delete').off();
    }
}

function deleteAvatar (avatar, getId) {
    var isHasUploadedImg = function isHasUploadedImg ($block) {
            return defaultLogo.indexOf($block.attr('src')) === -1;
        },
        hideDeleteBtn = function hideDeleteBtn (avatarName) {
            return $('#' + avatarName + 'Delete').addClass('hide');
        },
        uploadAvatarInput = document.getElementById('fileupload');

    if ('userAvatar' === avatar) {
        $.iapi({
            module: 'staff.avatar',
            method: 'DELETE',
            id: getId,
            delete_image: 1
        }, function (data) {
            if (data) {
                _status(_s('Image removed successfully!'));

                $('#userAvatar' + getId).attr('src', noAvatar);
                $('#' + avatar + 'Delete').hide();

                if (user.id == getId) {
                    $('#tr_avatar, #userm img').attr('src', noAvatar);
                }
                uploadAvatarInput.value = '';
            } else {
                _status(_s('Couldn\'t delete image'));
            }

        });
    } else if ('companyLogo' === avatar && isHasUploadedImg($('#companyLogo'))) {
        if ($('.j-upload-company-logo-wrapper').length > 0) {
            setNewLogo(avatar, '/app/layout/images/general/humanitylogo.svg');
            hideDeleteBtn(avatar);
            imageConfirm();
        }
    } else if ('loginBg' === avatar && isHasUploadedImg($('#loginBg'))) {
        $.post('/app/admin/process.php', {
            delete_background: true
        }, function (Data) {
            $('#loginBg').attr('src', defaultLogo);
            hideDeleteBtn(avatar);

            if ('Deleted' === Data) {
                _status(_s('Background Deleted'));
            }
        });
    } else {
        return;
    }
}

/*DELETE COMPANY LOGO*/
function imageConfirm () {
    $.iapi({
        module: 'admin.avatar',
        method: 'DELETE',
        user_id: cal.user
    }, function (data) {
        if (data) {
            _status(_s('Image removed successfully!'));
            $('#userAvatarDelete').hide();
            $('#companyLogo').attr('src', defaultLogo);
            $('#userAvatarWrapper').off();
            $('#logoText').show();
        } else {
            _status(_s('Couldn\'t delete image'));
        }
    });
}
// FILE UPLOADER
$.fn.fileUploader = function (formData, url, position, module){
    var TOAST_SECS = 8;

    $(this).fileupload({
        url: url,
        dataType: 'json',
        formData: formData,
        maxFileSize: 10000000,
        singleFileUploads: true,
        autoUpload: true,
        dropZone: $('#FilesList'),
        /*Remove this after jquery update*/
        drop: function (e, data) {
            if (!(data.files instanceof Array)){
                data.files = [data.files];
            }
        }
    }).on('fileuploadadd', function (e, data) {
        var files = data.files || [];
        var name = files[0] && files[0].name ? files[0].name : '';

        if (name) {
            _status(_s('Uploading'), TOAST_SECS);
        }
        data.context = $('#abort-' + position).text('Uploading...').append('&nbsp&nbsp;<input type="button" class="btn-cancel" value="Cancel"/>').on('click', function () {
            data.abort();
            fadeOut(500, position);
        });
    }).on('fileuploadprocessalways', function (e, data) {
        if (data.files[data.index].error){
            $('.btn-cancel').trigger('click');
            alert(data.files[data.index].error);
            _status(data.files[data.index].error, TOAST_SECS);
        } else {
            data.submit();
        }

    }).on('fileuploadprogressall', function (e, data) {
        fadeIn(300, position);

        var progress = parseInt(data.loaded / data.total * 100, 10);

        $('#progress-' + position + ' .bar').css(
            'width',
            progress + 'px'
        );
    }).on('fileuploaddone', function (e, data) {
        var uploader = this;

        if ('shared' === position) {
            fadeOut(500);
            if (isNaN(parseInt(data.result, 10))) {
                _status(data.result, TOAST_SECS);
            } else {
                var successMsgUpload = _s('Upload Success');

                _status(successMsgUpload, TOAST_SECS);
                _sub('admin', 'ShowFiles');
            }
        } else {
            if ('99' == data.result) {
                _status(_s('Unable to Upload File..'), TOAST_SECS);
                fadeOut(500, position);
            } else if (data.result.status === responseStatus.CREATE_FAILED) {
                _status(_s(data.result.error), TOAST_SECS);
                fadeOut(500, position);
            } else {
                var successMsgFile = _s('File Uploaded');

                _status(successMsgFile, TOAST_SECS);
                if (uploader && uploader.blur) {
                    uploader.blur();
                }
                $.each(data.result.files, function (index, file) {
                    var base64url_encode = btoa(file.id);

                    if ('profile' === position) {
                        $('#StaffFileList ul').append('<li class="staff-file"><a href="/app/admin/file.php?fid=' + base64url_encode + '" rel="noopener noreferrer" target="_blank">' + DOMPurify.sanitize(file.name) + '</a> (' + Math.round(file.size / 1024) + ' KB) [' + '<a href="javascript://" aria-label="' + _s('Delete File') + '" onclick="admin_delete_file(' + file.id + ', ' + user.id + ');">x</a>]</li>');
                        $('#StaffFileList').closest('.j-parentBlock').find('.j-textEmpty').hide();
                    } else if ('training' === position) {
                        $('#ModuleFileList').append('<a href="/app/admin/file.php?fid=' + base64url_encode + '" rel="noopener noreferrer" target="_blank">' + DOMPurify.sanitize(file.name) + '</a> (' + Math.round(file.size / 1024) + ' KB) [' + '<a href="javascript://" onclick="training_delete_file(' + file.id + ', ' + module + ');">x</a>]<br>');

                    } else if ('homework' === position) {
                        $('#file_training_append').append('<div id="file_' + file.id + '">' + DOMPurify.sanitize(file.name) + '(' + Math.round(file.size / 1024) + ' KB) [ <a onclick="training_delete_homework_file(' + file.id + ',\'' + file.name + '\')">x</a> ]</div><br />');
                    }
                });

                fadeOut(500, position);
            }
        }
    }).on('fileuploadfail', function () {
        _status(_s('Upload failed. Please try again.'), TOAST_SECS);
        fadeOut(500, position);
    }).prop('disabled', !$.support.fileInput)
        .parent().addClass($.support.fileInput ? undefined : 'disabled');
};

function fadeIn (s, position) {
    $('.fileinput-button').hide();
    $('#progress-' + position).fadeIn(s);
    $('#abort-' + position).fadeIn(s);

}

function fadeOut (s, position){
    $('.fileinput-button').show();
    $('#abort-' + position).fadeOut(s);
    $('#progress-' + position).fadeOut(s);
}

/**
 *  Snippet for strings
 *  @usage document.getElementById("foo").innerHTML = jsSnippet(string, 8);
 */
function jsSnippet (string, limitTo){
    if (string.length > limitTo){
        string = string.substring(0, limitTo) + '..';
    }

    return string;
}

function createAndSubmitForm (action, inputs, method) {
    /* Create Form */
    var mapForm = document.createElement('form');

    mapForm.id = 'print_export_form';
    mapForm.method = method;
    mapForm.action = action;

    /* Append inputs */
    $.each(inputs, function (key, input){
        mapInput = document.createElement('input');
        mapInput.type = input.hasOwnProperty('type') ? input.type : 'text';
        mapInput.name = input.hasOwnProperty('name') ? input.name : '';
        mapInput.value = input.hasOwnProperty('value') ? input.value : '';
        mapForm.appendChild(mapInput);
    });

    /* Submit Form */
    document.body.appendChild(mapForm);
    mapForm.submit();

    /* Remove Form */
    document.body.removeChild(mapForm);
}

/**
* Hides the primary navigation labels only when the items do not fit next to the right-hand group.
* Below 1024px the labels are always hidden by CSS, so the compact mode stays off there.
*/
var NavCompact = (function () {
    var $nav = null,
        $wrapper = null,
        onChange = null,
        frameId = 0;

    function getItemsWidth () {
        return $('#topMenu').children('li').get().reduce(function (total, item) {
            return total + item.getBoundingClientRect().width;
        }, 0);
    }

    function refresh () {
        if (!$nav) {
            return;
        }

        $nav.addClass('nav--measuring').removeClass('nav--compact');
        $nav.toggleClass('nav--compact', window.innerWidth > 1024 && getItemsWidth() > $wrapper[0].clientWidth);
        $nav[0].getBoundingClientRect();
        $nav.removeClass('nav--measuring');

        if (onChange) {
            onChange();
        }
    }

    function scheduleRefresh () {
        if (frameId) {
            return;
        }

        frameId = window.requestAnimationFrame(function () {
            frameId = 0;
            refresh();
        });
    }

    function init (changeCallback) {
        $nav = $('#_nav');
        $wrapper = $('.topMenu__wrapper');
        onChange = changeCallback || null;

        $(window).on('resize load', scheduleRefresh);

        if (window.ResizeObserver) {
            new ResizeObserver(scheduleRefresh).observe($wrapper[0]);
        }

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(scheduleRefresh);
        }

        refresh();
    }

    return {
        init: init,
        refresh: refresh
    };
})();

function toggleMainNavItem (itemName) {
    var $item = $('.j-primary-navigation-qtip[data-item-name="' + itemName + '"]');
    var $itemChildren = $item.children();
    var itemClassHide = $itemChildren.hasClass('hide');

    $item.toggle();
    $itemChildren[itemClassHide ? 'removeClass' : 'addClass']('hide');
    NavCompact.refresh();
}

function userConfirm (userId, status) {
    if (!status){
        status = false;
    }
    $.iapi({
        module: 'staff.employee',
        method: 'UPDATE',
        id: userId,
        confirm_user: status
    }, function (data) {
        if (data) {
            if (status) {
                _status(_s('Request approved!'));
                _sub('requests', 'staffrequest');
            } else {
                _status(_s('Confirmation Sent To User!'));
                _sub('staff', 'OverView', 'id=' + DOMPurify.sanitize(userId));
            }
        }
    });
}

function toggleBranding (storeId) {
    var brandingEnable = $('#enable_branding').is(':checked') ? 1 : 0;

    $.get('/team/accounts/process.php', {
        action: 'enable_custom_branding',
        storeId: storeId,
        enable: brandingEnable
    }, function (data) {
        if (data === 'ok') {
            _status('Setting changed');
        } else {
            _status('Something went wrong!');
        }
    });
}

function toggleAPIEnable (storeId) {
    var APIEnable = $('#enable_api').is(':checked') ? 1 : 0;

    $.get('/team/accounts/process.php', {
        action: 'enable_api',
        storeId: storeId,
        enable: APIEnable
    }, function (data) {
        if (data === 'ok') {
            _status('Setting changed');
        } else {
            _status('Something went wrong!');
        }
    });
}

function toggleCustomReports (storeId) {
    var reportsEnabled = $('#enable_custom_reports').is(':checked') ? 1 : 0;

    $.get('/team/accounts/process.php', {
        action: 'enable_custom_reports',
        storeId: storeId,
        enable: reportsEnabled
    }, function (data) {
        if (data === 'ok') {
            _status('Setting changed');
        } else {
            _status('Something went wrong!');
        }
    });
}

/**
 * Gets/sets if there is an active request and we are waiting for the contents to load
 *
 * @param {boolean} newValue
 * @returns boolean
 */
function contentLoading(newValue) {
    // Old value unknown, new not set, returning default
    if (typeof window.contentLoadingFlag === 'undefined' && typeof newValue !== 'boolean') {
        return false;
    }

    if (typeof newValue === 'boolean') {
        window.contentLoadingFlag = newValue;
    }

    return window.contentLoadingFlag;
}

/**
 * Gets/sets disabled property of the primary action button
 *
 * @param {boolean} newState
 * @returns boolean
 */
function primaryActionButtonSetDisabled(newState) {
    var $primaryActionButton = $('#act_primary');

    if (typeof newState === 'boolean') {
        $primaryActionButton.prop('disabled', newState);
    }

    return $primaryActionButton.prop('disabled');
}

/**
 * Marks request state and disables/enables primary button accordingly
 *
 * @param {boolean} newStatus
 */
function requestActiveStatus(newStatus) {
    contentLoading(newStatus);
    primaryActionButtonSetDisabled(newStatus);
}

/**
 * @param {string} companyId
 */
function toggleCoverShifts(companyId) {
    var coverShiftsEnabled = $('#cover_shifts').is(':checked') ? 1 : 0;

    if (1 === coverShiftsEnabled) {
        $('#label_cover_shifts').text('Enabled');
    } else {
        $('#label_cover_shifts').text('Disabled');
    }

    $.get('/team/accounts/process.php', {
        action: 'enable_cover_shifts',
        companyId: companyId,
        enable: coverShiftsEnabled
    }, function(data) {
        if ('ok' === data) {
            _status('Setting changed.');
        } else {
            _status('Setting is not saved, something went wrong!');
        }
    });
}

function togglePositionAssignment(companyId) {
    $.get('/team/accounts/process.php', {
        action: 'unlock_position_assignment',
        companyId: companyId,
        enable: $('#position_assignment').is(':checked') ? 1 : 0
    }, function(data) {
        if ('ok' === data) {
            _status('Setting changed.');
        } else {
            _status('Setting is not saved, something went wrong!');
        }
    });
}

function setOverflowOnBody(value) {
    var bodyElement = document.getElementById('_fbody');

    bodyElement.style.overflow = value;
}

(function () {
    function applyDatepickerA11y() {
        if (!window.jQuery || !jQuery.datepicker || !jQuery.datepicker._updateDatepicker || jQuery.datepicker.__a11yPatched) {
            return;
        }
        var dp = jQuery.datepicker;

        dp.__a11yPatched = true;
        var originalUpdate = dp._updateDatepicker;

        function dayAnchors(div) {
            return Array.prototype.slice.call(div.querySelectorAll('.ui-datepicker-calendar td a'));
        }

        function setRovingTabindex(div) {
            var anchors = dayAnchors(div);

            if (!anchors.length) {
                return;
            }
            var activeIdx = anchors.findIndex(function (a) {
                return (a.parentNode.className || '').indexOf('ui-datepicker-current-day') > -1
                    || (a.className || '').indexOf('ui-state-active') > -1;
            });

            if (activeIdx < 0) {
                activeIdx = anchors.findIndex(function (a) {
                    return (a.className || '').indexOf('ui-state-highlight') > -1;
                });
            }
            if (activeIdx < 0) {
                activeIdx = 0;
            }
            anchors.forEach(function (a) {
                a.setAttribute('tabindex', '0');
            });
            div.__activeIdx = activeIdx;
        }

        function labelDays(div, inst) {
            var dayNames = dp._get(inst, 'dayNames');
            var monthNames = dp._get(inst, 'monthNames');
            var t = typeof _s === 'function' ? _s : function (text) { return text; };

            dayAnchors(div).forEach(function (a) {
                var cell = a.parentNode;

                if (!cell.hasAttribute('data-year')) {
                    return;
                }
                var date = new Date(+cell.getAttribute('data-year'), +cell.getAttribute('data-month'), +a.textContent);
                var label = dayNames[date.getDay()] + ', ' + monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();

                if (cell.classList.contains('ui-datepicker-today')) {
                    label += ', ' + t('Today');
                }
                if (cell.classList.contains('ui-datepicker-current-day')) {
                    label += ', ' + t('selected');
                }
                a.setAttribute('aria-label', label);
            });
        }

        dp._updateDatepicker = function (inst) {
            var beforeDiv = inst.dpDiv && inst.dpDiv[0];
            var focusBefore = document.activeElement;
            var focusWasSelect = !!(beforeDiv && focusBefore
                && beforeDiv.contains(focusBefore)
                && focusBefore.tagName === 'SELECT');

            originalUpdate.call(this, inst);
            try {
                var div = (inst.dpDiv && inst.dpDiv[0]) || document.getElementById('ui-datepicker-div');

                if (!div) {
                    return;
                }
                setRovingTabindex(div);
                if (dp._get(inst, 'labelDays')) {
                    labelDays(div, inst);
                }
                if (focusWasSelect && !div.contains(document.activeElement)) {
                    var restore = div.querySelector('.ui-datepicker-current-day a')
                        || div.querySelector('.ui-datepicker-calendar td a.ui-state-active')
                        || div.querySelector('.ui-datepicker-calendar td a.ui-state-highlight')
                        || div.querySelector('.ui-datepicker-calendar td a');

                    if (restore) { restore.focus(); }
                }
                if (div.__a11yKeyBound) {
                    return;
                }
                div.__a11yKeyBound = true;
                div.addEventListener('keydown', function (e) {
                    var focusEl = document.activeElement;
                    var activeInGrid = focusEl
                        && typeof focusEl.closest === 'function'
                        && focusEl.closest('.ui-datepicker-calendar')
                        && div.contains(focusEl);

                    if (!activeInGrid && e.key !== 'Escape') {
                        var isPrevNext = focusEl && focusEl.classList && (focusEl.classList.contains('ui-datepicker-prev') || focusEl.classList.contains('ui-datepicker-next'));
                        var isActivate = (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 13 || e.keyCode === 32);

                        if (isPrevNext && !e.defaultPrevented && isActivate) {
                            e.preventDefault();
                            var isPrev = focusEl.classList.contains('ui-datepicker-prev');

                            focusEl.click();
                            var newBtn = div.querySelector(isPrev ? '.ui-datepicker-prev' : '.ui-datepicker-next');

                            if (newBtn) { newBtn.focus(); }
                        }
                        return;
                    }
                    var anchors = dayAnchors(div);

                    if (!anchors.length) {
                        return;
                    }
                    var cur = anchors.indexOf(document.activeElement);

                    if (cur < 0) {
                        cur = div.__activeIdx || 0;
                    }
                    if (cur >= anchors.length) {
                        cur = anchors.length - 1;
                    }
                    var next = cur;
                    var moved = true;

                    switch (e.key) {
                    case 'ArrowRight': next = Math.min(cur + 1, anchors.length - 1); break;
                    case 'ArrowLeft': next = Math.max(cur - 1, 0); break;
                    case 'ArrowDown': next = Math.min(cur + 7, anchors.length - 1); break;
                    case 'ArrowUp': next = Math.max(cur - 7, 0); break;
                    case 'Home': next = 0; break;
                    case 'End': next = anchors.length - 1; break;
                    case 'PageUp': {
                        e.preventDefault();
                        var prev = div.querySelector('.ui-datepicker-prev');

                        if (prev) {
                            prev.click(); var pa = dayAnchors(div);

                            (pa[div.__activeIdx] || pa[0] || div).focus();
                        }
                        return;
                    }
                    case 'PageDown': {
                        e.preventDefault();
                        var nxt = div.querySelector('.ui-datepicker-next');

                        if (nxt) {
                            nxt.click(); var na = dayAnchors(div);

                            (na[div.__activeIdx] || na[0] || div).focus();
                        }
                        return;
                    }
                    case 'Enter':
                    case ' ':
                        e.preventDefault();
                        if (document.activeElement) { document.activeElement.click(); }
                        return;
                    case 'Escape': {
                        e.preventDefault();
                        var input = (dp._curInst && dp._curInst.input) ? dp._curInst.input[0] : null;

                        dp._hideDatepicker();
                        if (input) { input.focus(); }
                        return;
                    }
                    default: moved = false;
                    }
                    if (moved) {
                        e.preventDefault();
                        anchors[next].focus();
                        div.__activeIdx = next;
                    }
                });
            } catch (err) {
                if (window.console) { console.warn('datepicker a11y enhancement failed', err); }
            }
        };

        document.addEventListener('focusin', function (e) {
            if (!dp._datepickerShowing || !dp._curInst || !dp._curInst.dpDiv) {
                return;
            }
            var dpDiv = dp._curInst.dpDiv[0];

            if (!dpDiv || (dpDiv.classList && dpDiv.classList.contains('ui-datepicker-inline'))) {
                return;
            }
            if (dpDiv.contains(e.target)) {
                return;
            }
            var input = dp._curInst.input && dp._curInst.input[0];

            if (input === e.target) {
                return;
            }
            dp._hideDatepicker();
        });
    }

    if (window.jQuery && jQuery.datepicker) {
        applyDatepickerA11y();
    } else if (window.jQuery) {
        jQuery(applyDatepickerA11y);
    }
})();

(function () {
    var HEADING_SEL = '.leftI h3.title, .leftI h3.ltitle, #LeftMenu h3.title, #LeftMenu h3.ltitle';
    var BRANDING_IMG_SEL = '#_cd_admin .admin-content img#logo, #_cd_admin .admin-content img#image';

    function apply() {
        Array.prototype.forEach.call(document.querySelectorAll(HEADING_SEL), function (h) {
            if (!h.getAttribute('aria-level')) {
                h.setAttribute('role', 'heading');
                h.setAttribute('aria-level', '2');
            }
        });
        Array.prototype.forEach.call(document.querySelectorAll(BRANDING_IMG_SEL), function (img) {
            if (!img.hasAttribute('alt')) {
                img.setAttribute('alt', '');
            }
        });
        Array.prototype.forEach.call(document.querySelectorAll('.sceditor-container iframe:not([title])'), function (f) {
            f.setAttribute('title', typeof _s === 'function' ? _s('Rich text editor') : 'Rich text editor');
        });
        Array.prototype.forEach.call(document.querySelectorAll('a.sceditor-button:not([aria-label])'), function (b) {
            var m = (b.className || '').match(/sceditor-button-([a-z-]+)/);

            if (m) {
                var name = m[1].replace(/-/g, ' ');

                b.setAttribute('aria-label', name.charAt(0).toUpperCase() + name.slice(1));
                b.setAttribute('role', 'button');
            }
        });
    }

    document.addEventListener('keydown', function (e) {
        var t = e.target;

        if (!t || !t.classList) {
            return;
        }
        if ((e.key === 'Enter' || e.key === ' ')
            && (t.classList.contains('j-viewBtn') || t.classList.contains('color-variant-link')
                || t.classList.contains('j-editNote') || t.classList.contains('j-deleteNote'))) {
            e.preventDefault();
            t.click();
            return;
        }
        if (e.key === ' ' && t.tagName === 'A' && t.getAttribute('role') === 'button') {
            e.preventDefault();
            t.click();
        }
    }, true);

    function init() {
        apply();
        try {
            var scheduled = false;
            var schedule = function () {
                if (scheduled) { return; }
                scheduled = true;
                (window.requestAnimationFrame || window.setTimeout)(function () {
                    scheduled = false;
                    apply();
                }, 50);
            };
            var observer = new MutationObserver(function (mutations) {
                for (var i = 0; i < mutations.length; i++) {
                    if (mutations[i].addedNodes.length) { schedule(); return; }
                }
            });

            observer.observe(document.body, { childList: true, subtree: true });
        } catch (e) {
            // MutationObserver unsupported — the initial pass above still runs.
        }
    }

    if (window.jQuery) {
        jQuery(init);
    } else if (document.readyState !== 'loading') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }
})();

(function () {
    var pendingId = null;
    var pendingAt = 0;

    document.addEventListener('change', function (e) {
        var t = e.target;

        if (t && t.id && t.tagName === 'SELECT') {
            pendingId = t.id;
            pendingAt = new Date().getTime();
        }
    }, true);

    function visibleById(id) {
        var el = document.getElementById(id);

        if (el && el.getClientRects().length > 0) {
            return el;
        }
        return null;
    }

    function reclaim(attempt) {
        if (!pendingId || (new Date().getTime() - pendingAt) > 10000) {
            return;
        }
        var el = visibleById(pendingId);

        if (el) {
            pendingId = null;
            try { el.focus(); } catch (err) { /* hidden/detached element */ }
            return;
        }
        if ((attempt || 0) < 6) {
            window.setTimeout(function () { reclaim((attempt || 0) + 1); }, 250);
        } else {
            pendingId = null;
        }
    }

    document.addEventListener('focusin', function (e) {
        if (e.target && (e.target.id === 'topFocusAnchor' || e.target.id === 'focus-start')) {
            window.setTimeout(reclaim, 0);
        }
    }, true);

    if (window.jQuery) {
        jQuery(document).ajaxComplete(function () {
            window.setTimeout(function () {
                var a = document.activeElement;

                if (!a || a === document.body || a === document.documentElement) {
                    reclaim();
                }
            }, 120);
        });
    }
})();

window.FocusOrderCorrector = (function () {
    'use strict';

    var TABBABLE_CANDIDATES = 'a[href], button, input:not([type="hidden"]), select, textarea, iframe, ' +
            '[tabindex], [contenteditable="true"]',
        RULES = [
            {
                anchor: '#dashboardtl_ #tab-messaging',
                segment: '#act_primary',
                isActive: function (anchor) {
                    return anchor.getAttribute('aria-selected') === 'true' || anchor.classList.contains('selected');
                }
            },
            {
                anchor: '#act_primary',
                segment: 'main#right ' + TABBABLE_CANDIDATES.split(', ').join(', main#right '),
                isActive: function () {
                    var tab = document.querySelector('#dashboardtl_ #tab-messaging');

                    return !!tab && (tab.getAttribute('aria-selected') === 'true' || tab.classList.contains('selected'));
                }
            },
            {
                anchor: '.trainingfilterTable #applyFiltersBtn',
                segment: '#staffviewchange_.controlsPanel__timelines .j-viewBtn'
            }
        ];

    function isVisible (el) {
        return !!el && el.getClientRects().length > 0 && window.getComputedStyle(el).visibility !== 'hidden';
    }

    function isTabbable (el) {
        return !el.disabled && el.tabIndex >= 0 && el.getAttribute('tabindex') !== '-1' && isVisible(el);
    }

    function visibleAll (selector) {
        return Array.prototype.filter.call(document.querySelectorAll(selector), isVisible);
    }

    function activeRules () {
        return RULES.map(function (rule) {
            var anchor = visibleAll(rule.anchor)[0],
                segment = anchor && (!rule.isActive || rule.isActive(anchor)) ? visibleAll(rule.segment) : [];

            return segment.length && segment.indexOf(anchor) === -1 ? {anchor: anchor, segment: segment} : null;
        }).filter(Boolean);
    }

    function naturalOrder (current) {
        var order = Array.prototype.filter.call(document.querySelectorAll(TABBABLE_CANDIDATES), isTabbable),
            at = 0;

        if (current && current.compareDocumentPosition && order.indexOf(current) === -1) {
            while (at < order.length && !(current.compareDocumentPosition(order[at]) & Node.DOCUMENT_POSITION_FOLLOWING)) {
                at++;
            }
            order.splice(at, 0, current);
        }

        return order;
    }

    function correctedOrder (natural, rules) {
        return rules.reduce(function (order, rule) {
            var segment = rule.segment.filter(function (el) { return order.indexOf(el) !== -1; }),
                rest;

            if (!segment.length || order.indexOf(rule.anchor) === -1) {
                return order;
            }

            rest = order.filter(function (el) { return segment.indexOf(el) === -1; });
            Array.prototype.splice.apply(rest, [rest.indexOf(rule.anchor) + 1, 0].concat(segment));

            return rest;
        }, natural);
    }

    function isInRule (el, rules) {
        return rules.some(function (rule) {
            return el === rule.anchor || rule.segment.indexOf(el) !== -1;
        });
    }

    function isNearRule (target, step, rules) {
        var all = document.querySelectorAll(TABBABLE_CANDIDATES),
            at = Array.prototype.indexOf.call(all, target);

        if (at === -1 || isInRule(target, rules)) {
            return true;
        }

        for (at += step; at >= 0 && at < all.length; at += step) {
            if (isTabbable(all[at])) {
                return isInRule(all[at], rules);
            }
        }

        return false;
    }

    function onKeyDown (event) {
        var rules,
            natural,
            corrected,
            step,
            expected;

        if (event.key !== 'Tab' || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) {
            return;
        }

        rules = activeRules();
        if (!rules.length) {
            return;
        }

        if (!isNearRule(event.target, event.shiftKey ? -1 : 1, rules)) {
            return;
        }

        natural = naturalOrder(event.target);
        corrected = correctedOrder(natural, rules);
        step = event.shiftKey ? -1 : 1;

        if (natural.indexOf(event.target) === -1 || corrected.indexOf(event.target) === -1) {
            return;
        }

        expected = corrected[corrected.indexOf(event.target) + step];

        if (expected && expected !== natural[natural.indexOf(event.target) + step]) {
            event.preventDefault();
            expected.focus();
        }
    }

    function init () {
        if (!window.__a11yFocusOrderBound) {
            window.__a11yFocusOrderBound = true;
            document.addEventListener('keydown', onKeyDown, true);
        }
    }

    return {init: init};
})();

window.FocusOrderCorrector.init();
